import React, { FunctionComponent, useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { Link, useParams } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import queryString from 'query-string';
import withStyles from 'react-jss';
import { path } from 'ramda';
import { useQuery } from 'react-apollo';

import { ClassProp } from 'helpers/types';
import { useDatePicker } from 'components/DatePicker/DatePicker.context';
import { getUserIdentityId } from 'scenes/Report/Report.helper';
import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';

const styles = {
  buttonBar: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    width: '23rem',
  },
  buttonBarBtn: {
    float: 'left',
  },
  button: {
    backgroundColor: '#683caf !important',
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.8rem',
    margin: '.25rem 0 .25rem 0.75rem !important',
    opacity: 1,
    padding: '0.5rem 1.25rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.25rem !important',
    display: 'inline-block',
    height: '2.25rem',
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
};

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const DownloadData: FunctionComponent<Props> = ({ classes }) => {
  const [userIdentityId, setIdentityId] = useState<string>('');
  const { merchantId } = useParams<any>();
  const { data, loading } = useQuery(GET_PROFILE);
  const { startDate, endDate } = useDatePicker();

  useEffect(() => {
    (async () => {
      const credentials = await Auth.currentUserCredentials();
      setIdentityId(getUserIdentityId(credentials));
    })();
  }, []);

  if (loading) return <Icon name="spinner" loading />;

  const params = {
    startDate,
    endDate,
    userIdentityId,
    merchantId: merchantId || path(['userProfile', 'merchantId'], data),
    exportJobType: 'CLOF',
  };

  return (
    <ul className={classes.buttonBar}>
      <li className={classes.buttonBarBtn}>
        <Link
          className={classes.button}
          to={{
            pathname: '/csv-export/create',
            search: queryString.stringify({
              ...params,
              runForDateType: 'CARD_TRANSACTION',
            }),
          }}
        >
          <Icon name="download" />
          Transactions Report
        </Link>
      </li>
      <li>
        <Link
          className={classes.button}
          to={{
            pathname: '/csv-export/create',
            search: queryString.stringify({
              ...params,
              runForDateType: 'WALLET_PAYOUT',
            }),
          }}
        >
          <Icon name="download" />
          Billing Report
        </Link>
      </li>
    </ul>
  );
};

export default withStyles(styles)(DownloadData);
